import React from 'react';

export function Home() {
  return (
    <>
      <svg width="22" height="25" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.5 10.0247L11.5 0.858032L22.5 10.0247V22.858H17H14.25V15.5247H8.75V22.858H6H0.5V10.0247Z"
          fill="currentColor"
        />
      </svg>
      Home
    </>
  );
}
